import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import GTRModal from './GTRModal';
import Merchant from './Merchant';

class MerchantModal extends Component {
  render() {
    const { history } = this.props;
    return (
      <GTRModal history={history}>
        <Merchant {...this.props} />
      </GTRModal>
    );
  }
}

export default MerchantModal;